<template>
  <section
    id="journal-hero-section"
    class="hero-section"
  >
    <div class="container">
      <div class="img-wrapper">
        <img
          v-if="mainArticleImage"
          :src="mainArticleImage"
          alt="hero illustration"
        />
        <NuxtPicture
          v-else
          src="images/common/article-placeholder.svg"
          alt="hero illustration"
        />
      </div>
      <div class="title-wrapper">
        <nuxt-link
          v-if="mainArticle"
          :to="`article/${mainArticle?.slug}`"
        >
          <p class="info">{{ mainArticleTag }}</p>
          <p class="date">
            {{ mainArticle.published_at }} · {{ mainArticle.read_time }}
          </p>
          <h1 class="title">{{ mainArticle.title }}</h1>
          <p class="description">
            {{ mainArticle.description }}
          </p>
          <ReadMore />
        </nuxt-link>
      </div>
    </div>
  </section>
</template>

<script>
import ReadMore from '~/components/Common/ReadMore/ReadMore.vue';
import cloudinaryImage from '~/utils/helpers/cloudinaryImage';
import { useJournalStore } from '~/stores/journal';

export default {
  components: {
    ReadMore,
  },
  data() {
    return {
      triangleAnimated: '',
      illustrationAnimated: '',
      observer: null,
      journalStore: useJournalStore(),
    };
  },
  computed: {
    mainArticle() {
      return this.journalStore.mainArticle;
    },
    mainArticleTag() {
      return this.mainArticle.tags
        ? this.mainArticle.tags[0].title
        : 'featured article';
    },
    mainArticleImage() {
      return this.mainArticle?.featured_image
        ? cloudinaryImage({
            imagePath: this.mainArticle.featured_image,
            width: 1700,
            height: 720,
          })
        : null;
    },
  },
  mounted() {
    const callback = (entries) => {
      if (entries[0].isIntersecting) {
        this.triangleAnimated = '';
        this.illustrationAnimated = '';
      } else {
        this.triangleAnimated = 'triangle-animated';
        this.illustrationAnimated = 'illustration-animated';
      }
    };

    this.observer = new IntersectionObserver(callback.bind(this), {
      root: null,
      rootMargin: '0px',
      threshold: 1,
    });
    const section = document.querySelector('#journal-hero-section');
    this.observer.observe(section);
  },
};
</script>

<style lang="scss" scoped>
@import './HeroSection.scss';
</style>
